import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  animate,
  AnimationEvent,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { StaticStorage } from '$core/services/static';

@Component({
  selector: 'app-footer-gov',
  templateUrl: './footer-gov.component.html',
  styleUrls: ['./footer-gov.component.scss'],
  animations: [
    trigger('drag', [
      state('prev', style({ left: '-{{ doubleCarouselOffset }}px' }), {
        params: { doubleCarouselOffset: 2 * (250 + 30) },
      }),
      state('init', style({ left: '-{{ carouselOffset }}px' }), {
        params: { carouselOffset: 250 + 30 },
      }),
      state('next', style({ left: 0 })),

      transition(`* => ${'init'}`, []),
      transition('* => *', animate('500ms ease-in-out')),
    ]),
  ],
})
export class FooterGovComponent implements OnInit, AfterViewInit {
  private readonly staticStorage = inject(StaticStorage);

  @ViewChild('carousel', { static: false })
  public carouselEl: ElementRef<HTMLElement>;

  @ViewChild('carouselItems', { static: false })
  public carouselItemsEl: ElementRef<HTMLElement>;

  public items = [];

  public carouselState = 'init';

  public carouselOffset = 250 + 30; // card width and gap will be replaced by computed values

  public ngOnInit(): void {
    this.items = this.staticStorage.static().footer_slider.sections[0].items;
    const visibleItems = 4;
    const visibleWithSpare = visibleItems + 2;

    if (this.items.length < visibleWithSpare) {
      this.items = this.items.concat(this.items);
    }
  }

  public ngAfterViewInit(): void {
    this.resizeItemsContainer();
  }

  @HostListener('window:resize')
  public resizeItemsContainer() {
    if (!this.carouselEl) {
      return;
    }
    const carouselBtnEl = this.carouselEl.nativeElement.childNodes.item(
      0
    ) as HTMLElement;
    const ul = this.carouselItemsEl.nativeElement.firstChild as HTMLElement;
    const firstLi = ul.children.item(0) as HTMLElement;
    const firstLiStyle = window.getComputedStyle(firstLi);
    const itemWidth = firstLi.offsetWidth;
    const itemsGap = parseInt(firstLiStyle.marginRight, 10);
    const btnWidth = carouselBtnEl.offsetWidth;
    const itemsContainerStyle = window.getComputedStyle(
      this.carouselItemsEl.nativeElement
    );
    const controlsMargin = parseInt(itemsContainerStyle.marginRight, 10);
    const controlsWidth = 2 * (btnWidth + controlsMargin);
    const available = this.carouselEl.nativeElement.offsetWidth - controlsWidth;
    const maxItemsCount = Math.floor(
      (available + itemsGap) / (itemWidth + itemsGap)
    );
    const containerWidth = maxItemsCount * (itemWidth + itemsGap) - itemsGap;

    this.carouselOffset = itemWidth + itemsGap;
    this.carouselItemsEl.nativeElement.style.maxWidth = `${containerWidth}px`;
  }

  public prev() {
    this.carouselState = 'prev';
  }

  public next() {
    this.carouselState = 'next';
  }

  public animEnd(event: AnimationEvent) {
    if (event.toState === 'next') {
      const last = this.items.pop();

      this.items.unshift(last);
    } else if (event.toState === 'prev') {
      const first = this.items.shift();

      this.items.push(first);
    }

    this.carouselState = 'init';
  }
}
